import { round } from "./round";

export type TimeParts = {
  hours: number;
  minutes: number;
  seconds: number;
};

export const minutesToTimeParts = (minutes: number | null | undefined): TimeParts => {
  if (minutes === null || minutes === undefined || Number.isNaN(minutes)) {
    return { hours: 0, minutes: 0, seconds: 0 };
  }

  const totalSeconds = Math.round(minutes * 60);
  const hours = Math.floor(totalSeconds / 3600);
  const remainingSeconds = totalSeconds % 3600;

  return {
    hours,
    minutes: Math.floor(remainingSeconds / 60),
    seconds: remainingSeconds % 60,
  };
};

export const timePartsToMinutes = (parts: TimeParts): number => {
  const { hours, minutes, seconds } = parts;

  return round(hours * 60 + minutes + seconds / 60, 2);
};
